import BtnTab from './BtnTab';

export default BtnTab;
